export enum EProfileTab {
  PERSONAL_DETAILS = 'personal-details',
  NOTIFICATIONS = 'notifications',
  STORE_DETAILS = 'store-details',
  SIGN_IN_SETTINGS = 'sign-in-settings',
  CO_HOSTS = 'co-hosts',
}
